import React from "react";
import useTitle from "../../useTitle";

function PageNotFound() {
  useTitle("Pagina non trovata");
  return <div>PageNotFound</div>;
}

export default PageNotFound;
